import CandidateQuestions from "./CandidateQuestions";

export default CandidateQuestions;
